export default __webpack_public_path__ + "static/media/E21.c15335b0.jpg";